<template>
  <b-row>
    <!-- <i class="fa fa-caret-left"></i> -->
    <b-col :sm="documentSize" style="display:inline-block">
      <div @click="switchFocusDoc" :class="{focusedDoc: focusDoc}">
        <pdf v-if="documentType === 'pdf' && documentDataForPDF.data" ref="pdf"
          :src="documentDataForPDF"
          :page="page" @progress="loadedRatio = $event"
          :rotate="rotation"
          @numPages="numPages = $event">
        </pdf>
        <img v-else ref="imgRef" :src="src"
          :style="`margin-bottom: ${mBottom}px; margin-top: ${mTop}px; transform: rotate(${rotation}deg);width:100%;`">
        </img>
      </div>

      <span style="display:inline-block;text-align:center;width:100%;">
        {{page + '/' + numPages}}
      </span>
    </b-col>
    <!-- <i class="fa fa-caret-right"></i> -->
  </b-row>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'DocumentViewer',
  props: {
    initSize: {
      type: Number,
      default: 3
    },
    page: {
      type: Number,
      default: 1
    },
    rotation: {
      type: Number,
      default: 0
    },
    src: {
      type: String,
      default: ''
    }
  },
  components: {
    pdf
  },
  data () {
    return {
      documentDataForPDF: {},
      documentSize: 3,
      documentType: '',
      focusDoc: false,
      initHeight: 0,
      initWidth: 0,
      loadedRatio: 0,
      mBottom: 0,
      mTop: 0,
      numPages: 1
    }
  },
  watch: {
    rotation (val) {
      let newHeight = 0
      if ((val / 90) % 2 === 1) {
        newHeight = this.$refs.imgRef.clientWidth
        // let newWidth = this.$refs.imgRef.clientHeight
      } else {
        newHeight = this.$refs.imgRef.clientHeight
        // let newWidth = this.$refs.imgRef.clientWidth
      }

      if (newHeight > this.initHeight) {
        this.mTop = newHeight / 4
        this.mBottom = newHeight / 4
      } else {
        this.mTop = 0
        this.mBottom = 0
      }
    }
  },
  created () {
    this.documentSize = this.initSize

    let fileHeader = this.src.split(',')[0]
    if (fileHeader === 'data:application/pdf;base64') {
      this.documentType = 'pdf'
      let binaryVersionOfThePdf = window.atob(this.src.split(',')[1])
      this.documentDataForPDF = {
        data: binaryVersionOfThePdf
      }
    }
  },
  mounted () {
    this.initHeight = this.$refs.imgRef.clientHeight
    this.initWidth = this.$refs.imgRef.clientWidth
    console.log(this.initWidth + 'x' + this.initHeight)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.changePage)
  },
  methods: {
    changePage (event) {
      event.preventDefault()
      switch (event.which) {
        case 37:
          if (this.page > 1) {
            this.page--
          }
          break
        case 38:
          if (this.documentSize < 12) {
            this.documentSize++
          }
          break
        case 39:
          if (this.page < this.numPages) {
            this.page++
          }
          break
        case 40:
          if (this.documentSize > 1) {
            this.documentSize--
          }
          break
        default:
          break
      }
    },
    switchFocusDoc () {
      if (this.focusDoc) {
        window.removeEventListener('keydown', this.changePage)
      } else {
        window.addEventListener('keydown', this.changePage)
      }
      this.focusDoc = !this.focusDoc
    }
  }
}
</script>
<style scoped>
.focusedDoc {
  border: 5px solid cyan;
}
</style>



// WEBPACK FOOTER //
// DocumentViewer.vue?55f3a4b0